<template>
  <v-app id="inspire">
    <v-navigation-drawer v-model="drawer" app v-if="loggedIn">
      <template v-slot:prepend>
        <v-list>
          <v-list-item>
            <v-img src="./assets/donapp_logo.png"></v-img>
          </v-list-item>
          <v-list-item
            link
            two-line
            @click="$router.push({ name: 'userpage' })"
          >
            <v-list-item-content>
              <v-list-item-title class="title">
                {{ loggedUser.user_first_name }}
                {{ loggedUser.user_last_name }}
                </v-list-item-title>
              <v-list-item-subtitle>{{
                loggedUser.username
              }}</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-icon>mdi-dots-vertical</v-icon>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </template>

      <v-divider></v-divider>

      <v-list nav dense>
        <v-list-item
          link
          @click="$router.push({ name: 'dashboard' })"
          v-if="loggedUser.role === '1'"
        >
          <v-list-item-icon>
            <v-icon>mdi-view-dashboard</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Dashboard</v-list-item-title>
        </v-list-item>

        <v-list-item
          link
          @click="
            $router.push({
              path: '/clients/' + loggedUser.client,
              params: { clientId: loggedUser.client },
            })
          "
          v-if="loggedUser.role === '2'"
        >
          <v-list-item-icon>
            <v-icon>mdi-view-dashboard</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Dashboard</v-list-item-title>
        </v-list-item>

        <v-list-item
          link
          @click="
            $router.push({
              path: '/merchants/' + loggedUser.merchant,
              params: { merchantId: loggedUser.merchant },
            })
          "
          v-if="loggedUser.role === '3'"
        >
          <v-list-item-icon>
            <v-icon>mdi-view-dashboard</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Dashboard</v-list-item-title>
        </v-list-item>

        <v-list-item
          link
          @click="$router.push({ name: 'campaigns' })"
          v-if="loggedUser.role === '1'"
        >
          <v-list-item-icon>
            <v-icon>mdi-star</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Campaigns</v-list-item-title>
        </v-list-item>

        <v-list-item
          link
          @click="$router.push({ name: 'npos' })"
          v-if="loggedUser.role === '1'"
        >
          <v-list-item-icon>
            <v-icon></v-icon>
          </v-list-item-icon>
          <v-list-item-title>Npos</v-list-item-title>
        </v-list-item>

        <v-list-item
          link
          @click="$router.push({ name: 'clients' })"
          v-if="loggedUser.role === '1'"
        >
          <v-list-item-icon>
            <v-icon>mdi-star</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Clients</v-list-item-title>
        </v-list-item>

        <v-list-item
          link
          @click="$router.push({ name: 'merchants' })"
          v-if="loggedUser.role === '1'"
        >
          <v-list-item-icon>
            <v-icon></v-icon>
          </v-list-item-icon>
          <v-list-item-title>Merchant</v-list-item-title>
        </v-list-item>

        <v-list-item
          link
          @click="$router.push({ name: 'users' })"
          v-if="loggedUser.role === '1'"
        >
          <v-list-item-icon>
            <v-icon>mdi-account-multiple</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Users</v-list-item-title>
        </v-list-item>
        <v-list-item
          link
          @click="$router.push({ name: 'messages' })"
          v-if="loggedUser.role === '2' || loggedUser.role === '3'"
        >
          <v-list-item-icon>
            <v-icon>mdi-chat</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Messages</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-navigation-drawer
      v-model="rightDrawer"
      app
      right
      stateless
      temporary
      width="70%"
      v-if="loggedIn"
    >
      <v-flex md12 sm12 lg12>
        <component :is="rightDrawerComponent || ''" />
      </v-flex>
    </v-navigation-drawer>
    <v-app-bar app color="primary" dark v-if="loggedIn">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <v-toolbar-title>Back-Office</v-toolbar-title>
    </v-app-bar>

    <v-main background="#ff0000">
      <router-view />
    </v-main>

    <v-snackbar
      v-for="(alert, index) in alerts.filter((s) => s.showing)"
      :key="alert.text + Math.random()"
      v-model="alert.showing"
      :timeout="alert.timeout"
      :color="alert.color"
      :style="`bottom: ${index * 60 + 8}px`"
    >
      {{ alert.text }}
      <v-btn text dark @click="alert.showing = false">Close</v-btn></v-snackbar
    >

    <v-footer color="primary" app v-if="loggedIn">
      <span class="white--text">&copy; Donapp 2020</span>
    </v-footer>
  </v-app>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import npoForm from '@/components/NewNpoForm.vue'

export default {
  name: 'App',

  computed: {
    ...mapState('init', ['statuses', 'relations']),
    ...mapState({
      auth: 'auth',
      alerts: (state) => state.alert.snackbars
    }),
    ...mapState('modal', ['modal']),
    ...mapState('layoutevents', ['rightDrawer', 'rightDrawerComponent']),

    loggedIn () {
      return this.auth.loggedIn
    },
    loggedUser () {
      return this.auth.user || null
    }
  },
  watch: {
    // whenever question changes, this function will run
    rightDrawer: function () {
      this.toggleRightDrawer = this.rightDrawer
    }
  },
  components: {
    'npo-form': npoForm
  },
  methods: {
    ...mapActions('init', ['loadStatuses', 'loadInterventionAreas', 'loadNpoRegistrationStatutes', 'loadMerchantClientRelations'])
  },
  created () {
    this.loadStatuses()
    this.loadInterventionAreas()
    this.loadNpoRegistrationStatutes()
    this.loadMerchantClientRelations()
  },

  data () {
    return {
      drawer: false,
      toggleRightDrawer: false
    }
  }
}
</script>
<style scoped>
/deep/ .v-main__wrap {
  background-color: rgba(0, 0, 0, 0.1);
}
</style>
